const SparkleIcon = () => (
  <svg className="error-sparkle" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"
      fill="currentColor"
    />
  </svg>
);

const Landing = () => {
  return (
    <div className="error-boundary">
      <div className="error-boundary-content">
        <div className="error-brand-row">
          <SparkleIcon />
          <div className="error-brand">Ramp.ai</div>
        </div>

        <div className="error-divider"></div>

        <p className="error-tagline">AI-powered business solutions</p>

        <p className="error-footer-help">
          Having trouble? <a href="mailto:support@rampwithai.com">Contact support</a>
        </p>
        <p className="error-footer-text">
          &copy; {new Date().getFullYear()} Ramp.ai LLC. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Landing;
